import { Component, OnInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  templateUrl: './text-editor.component.html'
})
export class TextEditorComponent extends DefaultEditor implements OnInit {
  ocultarTexto: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.cell.getColumn().title === 'Valor') {
      if (this.cell.getRow().getData().nombre === 'DASHBOARD_PERIODO') {
        this.ocultarTexto = true;
      }
    }
  }
}
